import type { User } from 'vms/features/accounts/types';

import { hasPermission } from './permissions';

export const canStopWorkForOther = (user: User | null | undefined) =>
  Boolean(
    user &&
    (hasPermission(user, 'assignWork') || hasPermission(user, 'stopWorkForOthers'))
  );

export const canAssignWork = (user: User | null | undefined) =>
  hasPermission(user, 'assignWork');
